export default [
    {
        name: 'base',
        data: {},
        items:
        [
            { name: 'lennaTexture', source: 'assets/batik_background.png', type: 'texture' },
        ]
    }
]
